const colors = {
    primary: {
        DEFAULT: '#1f56d2',
        50: '#d9e6f2',
        100: '#c2d5f2',
        200: '#a6c0f2',
        300: '#7da6f0',
        400: '#4b8def',
        500: '#3571d8',
        600: '#1f56d2', // Default color
        700: '#1945b9',
        800: '#183995',
        900: '#183176',
        950: '#111d43',
    },
    secondary: {
        DEFAULT: '#4b5563',
        50: '#f9fafb',
        100: '#f3f4f6',
        200: '#e5e7eb',
        300: '#d1d5db',
        400: '#9ca3af',
        500: '#6b7280',
        600: '#4b5563', // Default color
        700: '#374151',
        800: '#1f2937',
        900: '#111827',
        950: '#030712',
    },
    danger: {
        DEFAULT: '#dc2626',
        50: '#fef2f2',
        100: '#fee2e2',
        200: '#fecaca',
        300: '#fca5a5',
        400: '#f87171',
        500: '#ef4444',
        600: '#dc2626', // Default color
        700: '#b91c1c',
        800: '#991b1b',
        900: '#7f1d1d',
        950: '#450a0a',
    },
    success: {
        DEFAULT: '#16a34a',
        50: '#f0fdf4',
        100: '#dcfce7',
        200: '#bbf7d0',
        300: '#86efac',
        400: '#4ade80',
        500: '#22c55e',
        600: '#16a34a', // Default color
        700: '#15803d',
        800: '#166534',
        900: '#14532d',
        950: '#052e16',
    },
    info: {
        DEFAULT: '#2563eb',
        50: '#eff6ff',
        100: '#dbeafe',
        200: '#bfdbfe',
        300: '#93c5fd',
        400: '#60a5fa',
        500: '#3b82f6',
        600: '#2563eb', // Default color
        700: '#1d4ed8',
        800: '#1e40af',
        900: '#1e3a8a',
        950: '#172554',
    },
    warning: {
        DEFAULT: '#ea580c',
        50: '#fff7ed',
        100: '#ffedd5',
        200: '#fed7aa',
        300: '#fdba74',
        400: '#fb923c',
        500: '#f97316',
        600: '#ea580c', // Default color
        700: '#c2410c',
        800: '#9a3412',
        900: '#7c2d12',
        950: '#431407',
    },
};

export default colors;
